'use strict';

// Import Libraries
import React from 'react';
// Import JS Modules
import classNames from 'classnames';
// Import JSX Modules
import ProductImage from './product-image';

// -----------------------------------------------------------
//  ProductImageThumbnail
// -----------------------------------------------------------
const ProductImageThumbnail = props => {
  const optionAsset = props.index == 0 ? props.optionAsset : undefined;
  return (
    <div
      className={classNames(
        'thumbnail d-flex align-items-center justify-content-center',
        { selected: props.selected }
      )}
      role="radio"
      data-test-id="product-image-thumbnail"
      data-option-asset={optionAsset}
      aria-checked={props.selected}
      onClick={handleClick}
      onKeyDown={onKeyPressed}
      tabIndex={props.tabIndex}>
      <ProductImage {...props} url={props.thumbnail} optionAsset={optionAsset}/>
    </div>
  );

  function handleClick() {
    props.onClick(props.index);
  }

  function onKeyPressed(event) {
    if (event.keyCode === 13) {
      props.onClick(props.index);
    }
  }
};

export default ProductImageThumbnail;
